import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SdtService } from 'src/app/services/sdt.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppSettings } from 'src/app/shared/app-settings';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { timeZoneService } from 'src/app/services/timezone.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import moment from 'moment';
import 'moment-timezone';

@Component({
  selector: 'app-pm-details',
  templateUrl: './pm-details.component.html',
  styleUrls: ['./pm-details.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class PmDetailsComponent implements OnInit {
  siteUnitId: string;
  potentialId: string;
  pmDetails: any;
  pmForm: FormGroup;
  startDate: any;
  endDate: any;
  formattedStartDate: any;
  formattedEndDate: any;
  selectedDevicesLength: number;
  createdBy: any;
  updatedBy: any;
  createdTime: any;
  updatedTime: any;
  pmStartDate: any;
  pmEndDate: any;
  data: any;
  currentuser: any;
  reason: any;
  areInputsDisabled: boolean = true;
  isMarkedForDeletion: boolean = false;
  isSubmitEnabled: boolean = false;
  formattedDateTime: any;
  updatedAt: string;
  initialFormValues: any;
  timeZoneData: any;
  timeData: any;
  minDate: Date;
  formattedMinDate: string;
  selectedDate: any;
  formattedDate: string;
  selectedStartTime: any;
  selectedEndTime: any;
  selectedEndDate: any;
  pmstartDate: string;
  pmendDate: string;
  minPmend: Date;
  start: any;
  pmUqId: string;
  pmPotential: string;
  pmUnitId: string;
  timeZone: string;
  pmUqID: any;
  pmUnitID: any;
  pmPotentialID: any;
  pmTimezone: any;
  initialStartdate: string;
  initialEnddate: string;
  initialStartTime: any;
  initialEndTime: any;
  pmstartDates: string;
  pmendDates: string;
  timeCrossed: boolean = false;
  dateData: any;
  timeData1: any;

  constructor(
    private titleService: Title,
    private http: HttpClient, private sdtService: SdtService, private router: Router, public authService: AuthenticationService,
    public restService: RestService,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private timeZoneService: timeZoneService
  ) { 
    this.titleService.setTitle("Planned Maintenance Details");
    if (history.state) {
      let { pmUqId, pmPotential, pmUnitId, pmTimeZone } = history.state;
      this.pmUqID = pmUqId;
      this.pmUnitID =  pmUnitId;
      this.pmPotentialID = pmPotential;
      this.pmTimezone = pmTimeZone;
      this.getPlannedMaintenanceDetails(pmUnitId,pmPotential,pmUqId,pmTimeZone)
    }
    this.timeZoneData = this.timeZoneService.getDateParametersByTimeZone(this.pmTimezone)['currentTime'].split(' ')[0];
    this.dateData = this.changeDateFormat1(this.timeZoneData)
    this.timeData = this.timeZoneService.getDateParametersByTimeZone(this.pmTimezone)['currentTime'].split(' ')[1].slice(0,-3);
    this.timeData1 = this.timeZoneService.getDateParametersByTimeZone(this.pmTimezone)['currentTime'].split(' ')[1]
    const [year, month, day] = this.timeZoneData?.split('-').map(Number);
    this.startDate = new Date(year, month - 1, day);
    this.minDate = new Date(year, month - 1, day);
    this.formattedMinDate = `${this.minDate.getFullYear()}-${String(this.minDate.getMonth() + 1).padStart(2, '0')}-${String(this.minDate.getDate()).padStart(2, '0')}`;
    this.createForm();
  }

  ngOnInit(): void {

    this.currentuser = this.authService.currentUserValue;
    let title = this.titleService.getTitle();
    this.currentuser = this.authService.currentUserValue;


    this.pmForm = this.formBuilder.group({
      start_date: [{ value: '', disabled: this.areInputsDisabled }],
      start_time:[{ value: '', disabled: this.areInputsDisabled }],
      end_date: [{ value: '', disabled: this.areInputsDisabled }],
      end_time: [{ value: '', disabled: this.areInputsDisabled }]
    }, { validator: this.dateRangeValidator });

      this.pmForm.get('start_date').valueChanges.subscribe((start) => {
        this.start = new Date(start);
      });

      this.pmForm.get('start_time').valueChanges.subscribe(() => {});

      this.pmForm.get('end_date').valueChanges.subscribe(() => {});

      this.pmForm.get('end_time').valueChanges.subscribe(() => {});

      if (this.currentuser) {
        this.sdtService.formDataPM.pmcreatedBy = this.currentuser.email;
        this.sdtService.formDataPM.pmupdatedBy = this.currentuser.email
      }
    
      this.pmForm.valueChanges.subscribe(() => {
        this.checkDateRange();
      });
      
  }

  checkDateRange() {
    const startDate = this.pmForm.get('start_date').value;
    const startTime = this.pmForm.get('start_time').value;
    const endDate = this.pmForm.get('end_date').value;
    const endTime = this.pmForm.get('end_time').value;
    if (startDate && startTime && endDate && endTime && new Date(startDate) > new Date(endDate)) {
      this.isSubmitEnabled = false;
      this.toastr.warning('End date and time must be greater than start date and time.')
    }
  }

  dateRangeValidator(group: FormGroup): ValidationErrors | null {
    const startDate = group.controls['start_date'].value;
    const endDate = group.controls['end_date'].value;
  
    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      return { dateRange: true };
    }
    return null;
  }
  


  createForm() {
    this.pmForm = this.formBuilder.group({
      start_date: [{value: '', disabled: this.areInputsDisabled}, Validators.required],
      start_time: [{value: '', disabled: this.areInputsDisabled}, Validators.required],
      end_date: [{value: '', disabled: this.areInputsDisabled}, Validators.required],
      end_time: [{value: '', disabled: this.areInputsDisabled}, Validators.required]
    }, { validator: this.dateRangeValidator });

    this.pmForm.valueChanges.subscribe(() => {
    });
  }

 getPlannedMaintenanceDetails(pmUnitId,pmPotential,pmUqId,siteTimeZone){
    let url = AppSettings.GET_UNQ_PM + '/' + pmUnitId  + '/' + 'potential-id' + '/'+ pmPotential + '/' + 'deviceUniqueId' + '/' + pmUqId;
    this.restService.getRequest(url,'').subscribe((response)=>{
      this.pmDetails = response.data;
      localStorage.setItem('pmDetails', JSON.stringify(this.pmDetails));
      this.timeZone = siteTimeZone;
      const startDate = this.removeLastThreeChars(this.pmDetails?.pdStartDate);
      const endDate = this.removeLastThreeChars(this.pmDetails?.pdEndDate);
       this.formattedStartDate = this.formatDateTimeForInput(startDate);
       this.formattedEndDate = this.formatDateTimeForInput(endDate);
       const newStart = this.formattedStartDate.slice(0,10)
       const newTime = this.formattedStartDate.slice(11).slice(-6)

       const [selectedHours1, selectedMinutes1] = newTime.split(":").map(Number);
       const selectedTotalMinutes1 = selectedHours1 * 60 + selectedMinutes1;

       const [selectedHours, selectedMinutes] = this.timeData.split(":").map(Number);
       const selectedTotalMinutes = selectedHours * 60 + selectedMinutes;
       if(new Date(this.timeZoneData) > new Date(newStart) || ((new Date(this.timeZoneData).getTime() === new Date(newStart).getTime()) && (selectedTotalMinutes > selectedTotalMinutes1))){
          this.timeCrossed = true;
       } else {
        this.timeCrossed = false;
       }


       this.initialFormValues = {
        start_date: this.formatDateTimeForInput(this.pmDetails?.pdStartDate).slice(0, 10),
        start_time: this.formatDateTimeForInput(this.pmDetails?.pdStartDate).slice(11).slice(0,-3),
        end_date: this.formatDateTimeForInput(this.pmDetails?.pdEndDate).slice(0, 10),
        end_time: this.formatDateTimeForInput(this.pmDetails?.pdEndDate).slice(11).slice(0,-3)
      };
      this.pmForm.patchValue({
        start_date: this.initialFormValues.start_date,
        start_time: this.initialFormValues.start_time,
        end_date: this.initialFormValues.end_date,
        end_time: this.initialFormValues.end_time
        });     
      },(error)=>{
    })
  }

  changeDateFormat(dateString) {
    let parts = dateString.split("-");
    let year = parts[0];
    let month = parts[1];
    let day = parts[2];
    return month + "-" + day + "-" + year;
}

  areDatesEqual(dt1, dt2) {
    const date1 = moment(dt1);
    const date2 = moment(dt2);
    return date1.isSame(date2, 'day');
  }

  onStartDatechange(event: any){
    this.selectedDate = event.target.value;
    const date = new Date(this.selectedDate);

    this.pmstartDates = (date.getMonth() + 1).toString().padStart(2, '0') + '-'
                          + date.getDate().toString().padStart(2, '0') + '-'
                          + date.getFullYear();
    this.minPmend = new Date(this.pmstartDate)
    this.initialStartdate = this.changeDateFormat(this.initialFormValues.start_date)
    if(this.areDatesEqual(this.pmstartDates,this.initialStartdate)){
      this.isSubmitEnabled = false
    } else {
      this.isSubmitEnabled = true
    }
  }

  onEndDatechange(event: any){
    this.selectedEndDate = event.target.value;
    const date = new Date(this.selectedEndDate);
    this.pmendDates = (date.getMonth() + 1).toString().padStart(2, '0') + '-'
                        + date.getDate().toString().padStart(2, '0') + '-'
                        + date.getFullYear();
    this.initialEnddate = this.changeDateFormat(this.initialFormValues.end_date)
    if(this.areDatesEqual(this.pmendDates,this.initialEnddate)){
      this.isSubmitEnabled = false
    } else {
      this.isSubmitEnabled = true
    }
  }

  onStartTimeChange(event: any){
    this.selectedStartTime = event.target.value;
    this.initialStartTime = this.initialFormValues.start_time;
        const [selectedHours, selectedMinutes] = this.selectedStartTime.split(":").map(Number);
        const selectedTotalMinutes = selectedHours * 60 + selectedMinutes;

        const [timeDataHours, timeDataMinutes] = this.timeData.split(":").map(Number);
        const timeDataTotalMinutes = timeDataHours * 60 + timeDataMinutes;
        if ((this.areDatesEqual(this.selectedDate,this.timeZoneData))&&(selectedTotalMinutes < timeDataTotalMinutes)) {
            this.selectedStartTime = this.timeData;
            event.target.value = this.timeData;
            this.pmForm.get('start_time').setValue(this.timeData);
        }
        if(this.selectedStartTime !== this.initialStartTime){
          this.isSubmitEnabled = true
        } else {
          this.isSubmitEnabled = false
        }
  }

  onEndTimeChange(event: any){
    this.selectedEndTime = event.target.value;
    this.initialEndTime = this.initialFormValues.end_time;
    if (this.selectedStartTime && typeof this.selectedStartTime === 'string'){

    const [selectedHours, selectedMinutes] = this.selectedEndTime?.split(":").map(Number);
    const selectedTotalMinutes = selectedHours * 60 + selectedMinutes;

    const [timeDataHours, timeDataMinutes] = this.selectedStartTime?.split(":").map(Number);
    const timeDataTotalMinutes = timeDataHours * 60 + timeDataMinutes;
    
    if(!(this.areDatesEqual(this.formattedDate,this.formattedEndDate))&&(selectedTotalMinutes < timeDataTotalMinutes)){
      this.selectedEndTime = this.selectedStartTime;
      event.target.value = this.selectedStartTime;
      this.pmForm.get('end_time').setValue(this.selectedStartTime);
    } else {
      this.selectedEndTime = event.target.value;
      this.pmForm.get('end_time').setValue(this.selectedEndTime);
    }
   }
    if(this.selectedEndTime !== this.initialEndTime){
      this.isSubmitEnabled = true
    } else {
      this.isSubmitEnabled = false
    }
  }

  removeLastThreeChars(dateTimeStr: string): string {
    return dateTimeStr?.slice(0, -3);
  }

  formatDateTimeForInput(dateTimeStr: string): string {
    if (!dateTimeStr) {
      return '';
    }
    const [date, time] = dateTimeStr.split(' ');
    const [month, day, year] = date?.split('-');
    this.formattedDateTime = `${year}-${month}-${day} ${time}`;
    return this.formattedDateTime;
  }


  toggleEdit() {
    this.areInputsDisabled = !this.areInputsDisabled;
    if (this.areInputsDisabled) {
      this.pmForm.reset(this.initialFormValues);
      this.pmForm.disable();
      this.isSubmitEnabled = false;
      if(this.isMarkedForDeletion == true){
        this.isMarkedForDeletion = false
      }
    } else {
      this.pmForm.enable();
    }
  }


  toggleDeletion() {
    if (!this.areInputsDisabled) {
      this.isMarkedForDeletion = !this.isMarkedForDeletion;
      this.isSubmitEnabled = this.isMarkedForDeletion;
    }
  }
  

  onSubmit() {
    if (this.isMarkedForDeletion) {
      this.deletePmDetails(this.pmUnitID,this.pmUqID);
    } else {
      if (this.pmForm.dirty) {
        this.updatePmDetails();
      }
    }
  }
  

  deletePmDetails(pmUnitId,pmUqId) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '390px',
      data: { message: 'Are you sure to delete?' }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let url = AppSettings.GET_UNQ_PM + '/' + pmUnitId  + '/' + 'deviceUniqueId' + '/'+ pmUqId;
        this.restService.deleteRequest(url,'').subscribe((response)=>{
          this.toastr.success('Planned Maintenance for Device is Removed');
          this.router.navigate(['/monitors']);
        });
      }
    });
  }
  


  formatPM() {
    if (this.pmForm) {
      const startDate = new Date(this.pmForm.value.start_date);
      const startMonth = ('0' + (startDate.getMonth() + 1)).slice(-2);
      const startDay = ('0' + startDate.getDate()).slice(-2);
      const startYear = startDate.getFullYear();
      this.pmStartDate = startMonth + '-' + startDay + '-' + startYear;

      const endDate = new Date(this.pmForm.value.end_date);
      const endMonth = ('0' + (endDate.getMonth() + 1)).slice(-2);
      const endDay = ('0' + endDate.getDate()).slice(-2);
      const endYear = endDate.getFullYear();
      this.pmEndDate = endMonth + '-' + endDay + '-' + endYear;

      this.reason = this.pmForm.value.reason;
      this.createdBy = this.sdtService.createdBy;

      const now = new Date();
      const options = { timeZone: 'UTC' as const, year: 'numeric' as const, month: '2-digit' as const, day: '2-digit' as const, hour: '2-digit' as const, minute: '2-digit' as const, second: '2-digit' as const };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const formattedDate = formatter.format(now).replace(/\//g, '-').slice(0, -3);
      
      this.createdTime = formattedDate
      this.updatedTime = formattedDate
    }
  }

  changeDateFormat1(dateString) {
    let parts = dateString.split("-");
    let year = parts[0];
    let month = parts[1];
    let day = parts[2];
    return month + "-" + day + "-" + year;
  }

  updatePmDetails(){
    this.updatedBy = this.currentuser.email
    this.updatedAt = this.dateData + ' '+ this.timeData1

    let pdStartDate = `${this.pmstartDates ? this.pmstartDates : this.pmDetails.pdStartDate.slice(0, 10)} ${this.selectedStartTime ? this.selectedStartTime + ':00' : this.pmDetails.pdStartDate.slice(11)}`;
    let endDate = this.pmendDates ? this.pmendDates : this.pmDetails.pdEndDate.slice(0, 10);
    let endTime = this.selectedEndTime ? this.selectedEndTime + ':00': this.pmDetails.pdEndDate.slice(11);
    let pdEndDate = `${endDate} ${endTime}`;

    const updatePayload = [{
      accId: this.pmDetails?.accId,
      potentialId: this.pmDetails?.potentialId,
      siteUnitId: this.pmDetails?.siteUnitId,
      siteType: this.pmDetails?.siteType,
      deviceUniqueId: this.pmDetails?.deviceUniqueId,
      deviceType: this.pmDetails?.deviceType,
      type: this.pmDetails?.type,
      deviceName: this.pmDetails?.deviceName,
      siteName: this.pmDetails?.siteName,
      pdStartDate: pdStartDate,
      pdEndDate: pdEndDate,
      pdReason: this.pmDetails?.pdReason,
      createdAt: this.pmDetails?.createdAt.replace(/,/g, ''),
      updatedAt: this.updatedAt,
      createdBy: this.pmDetails?.createdBy,
      updatedBy: this.updatedBy    
    }];


    const updateUrl = AppSettings.API_ENDPOINT + '/' + AppSettings.PM_CREATE;
    this.http.post(updateUrl, updatePayload).subscribe(
      response => {
        this.router.navigateByUrl('/monitors');
        this.toastr.success('Planned Maintenance Updated Successfully')    
      },
      error => {
        this.toastr.error('Unable to Update PM. Please try again');
      }
    );
  }

  back(){
    this.router.navigateByUrl('/monitors')
  }
 
}
